import * as types from "../actions/actionTypes";

const initialState = {
  isLoadingEvents: true,
  isLoading: false,
  error: "",
  events: [],
  totalRecords: 0,
  subjects: [],
  forms: [],
  users: [],
  event: null,
  showModal: false,
  response: null
};

export default function eventReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_EVENTS:
      return { ...state, isLoadingEvents: true };
    case types.GET_EVENTS_ERROR:
      return { ...state, error: action.error, isLoadingEvents: false };
    case types.GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.events,
        totalRecords: action.totalRecords,
        isLoadingEvents: false
      };
    case types.GET_EVENTS_DETAILS_ERROR:
      return { ...state, error: action.error, isLoading: false };
    case types.GET_EVENTS_DETAILS_SUCCESS:
      return {
        ...state,
        event: action.event,
        isLoading: false
      };
    case types.GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
        isLoading: false
      };
    case types.CREATE_EVENT:
      return { ...state, isLoading: true };
    case types.GET_EVENTS_DETAILS:
      return { ...state, isLoading: true };
    case types.CREATE_EVENTS_ERROR:
      return { ...state, error: action.error, isLoading: false };
    case types.CLOSE_MODAL:
      return { ...state, showModal: false };
    case types.CREATE_EVENTS_SUCCESS:
      return {
        ...state,
        response: action.response,
        isLoading: false,
        showModal: false,
        error: ""
      };
      case types.UPDATE_EVENT:
        return { ...state, isLoading: true };
      case types.GET_EVENTS_DETAILS:
        return { ...state, isLoading: true };
      case types.UPDATE_EVENTS_ERROR:
        return { ...state, error: action.error, isLoading: false };
      case types.CLOSE_MODAL:
        return { ...state, showModal: false };
      case types.SHOW_MODAL:
        return { ...state, showModal: true };
      case types.UPDATE_EVENTS_SUCCESS:
        return {
          ...state,
          response: action.response,
          isLoading: false,
          showModal: false,
          error: ""
        };
    default:
      return state;
  }
}
